import { ReactElement } from 'react';

import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { PrimaryButton } from '@/components';
import RefreshIcon from '@mui/icons-material/Refresh';

type UsersListErrorProps = {
  refetch: VoidFunction;
};

export const UsersListError = (props: UsersListErrorProps): ReactElement => {
  return (
    <TableRow>
      <TableCell
        colSpan={7}
        sx={{
          borderBottom: 'none',
        }}
      >
        <Box
          sx={{
            height: 'calc(100vh - 450px)',
            display: 'grid',
            placeItems: 'center',
          }}
        >
          <Stack alignItems="center" spacing={4}>
            <Typography fontSize={24} fontWeight={600}>
              Oops! Something went wrong.
            </Typography>

            <PrimaryButton onClick={props.refetch} startIcon={<RefreshIcon />}>
              Retry
            </PrimaryButton>
          </Stack>
        </Box>
      </TableCell>
    </TableRow>
  );
};
